export default {
    /**
     * 股票列表滚动监听，并且更新滚动后，显示中的股票行情
     * @param event
     * @param data
     */
    onscrollIng(event, data) {
        if (this.scrollStart !== data.start) {
            this.scrollStart = data.start;
            // data.end - data.start
            // 更新股票行情
            this.updataItemDetails(data.start, Math.ceil(data.end), true);
        }
    }
}
